import React, { useEffect, useState } from 'react';
import IWall from 'components/interfaces/IWall';

import maximizeIcon from 'assets/maximize.svg';
import minimizeIcon from 'assets/minimize.svg';
import PrimaryButton from 'components/layout/buttons/PrimaryButton';

const sides = ['left', 'right', 'roof', 'floor'] as const;
type Sides = typeof sides[number];

const WoodyWallPreviewModal = ({
  offset,
  wall,
}: {
  offset: { x: number; y: number };
  wall: IWall;
}): JSX.Element => {
  const [maximized, setMaximize] = useState<Sides | null>(null);

  useEffect(() => {
    window.InitWoodyWallPreviewContexts();
  }, []);

  const render = () => {
    const props = {
      glassType: wall.glassType,
      profileColor: wall.profileColor,
      woodyFloorBackGroove: wall.woodyFloorBackGroove,
      woodyFloorGlassDepth: wall.woodyFloorGlassDepth,
      woodyFloorGlassGroove: wall.woodyFloorGlassGroove,
      woodyFloorGrooveDepth: wall.woodyFloorGrooveDepth,
      woodyFloorGrooveWidth: wall.woodyFloorGrooveWidth,
      woodyFloorGuideGroove: wall.woodyFloorGuideGroove,
      woodyFloorProfileHeight: wall.woodyFloorProfileHeight,
      woodyRoofBackGroove: wall.woodyRoofBackGroove,
      woodyRoofGlassDepth: wall.woodyRoofGlassDepth,
      woodyRoofGlassGroove: wall.woodyRoofGlassGroove,
      woodyRoofGrooveDepth: wall.woodyRoofGrooveDepth,
      woodyRoofGrooveWidth: wall.woodyRoofGrooveWidth,
      woodyRoofGuideGroove: wall.woodyRoofGuideGroove,
      woodyRoofProfileHeight: wall.woodyRoofProfileHeight,
      woodyLeftBackGroove: wall.woodyLeftBackGroove,
      woodyLeftGlassDepth: wall.woodyLeftGlassDepth,
      woodyLeftGlassGroove: wall.woodyLeftGlassGroove,
      woodyLeftGrooveDepth: wall.woodyLeftGrooveDepth,
      woodyLeftGrooveWidth: wall.woodyLeftGrooveWidth,
      woodyLeftGuideGroove: wall.woodyLeftGuideGroove,
      woodyLeftProfileHeight: wall.woodyLeftProfileHeight,
      woodyRightBackGroove: wall.woodyRightBackGroove,
      woodyRightGlassDepth: wall.woodyRightGlassDepth,
      woodyRightGlassGroove: wall.woodyRightGlassGroove,
      woodyRightGrooveDepth: wall.woodyRightGrooveDepth,
      woodyRightGrooveWidth: wall.woodyRightGrooveWidth,
      woodyRightGuideGroove: wall.woodyRightGuideGroove,
      woodyRightProfileHeight: wall.woodyRightProfileHeight,
      woodyGlassOffset: wall.woodyGlassOffset,
      woodyProfileWidth: wall.woodyProfileWidth,
    };
    window.RenderWoodyWallPreviews(props);
  };

  useEffect(() => {
    if (maximized === null) {
      window.InitWoodyWallPreviewContexts();
      window.ClearWoodyWallMaximizedPreviewContext();
    } else {
      window.InitWoodyWallMaximizedPreviewContext(maximized);
    }

    render();
  }, [maximized]);

  useEffect(() => {
    render();
  }, [wall]);

  const getTitle = (key: Sides) => {
    switch (key) {
      case 'right':
        return 'Right';
      case 'left':
        return 'Left';
      case 'floor':
        return 'Floor';
      case 'roof':
        return 'Roof';
      default:
        return '';
    }
  };

  if (maximized === null) {
    return (
      <div
        className="properties-edit-popup"
        id="woody-wall-previews"
        style={{
          transform: `translate(${offset.x}px, ${offset.y}px)`,
        }}
      >
        {sides.map((side) => (
          <div key={side}>
            <div className="preview-header">
              <div className="preview-header-title">
                <img
                  src={maximizeIcon}
                  alt="maximize-icon"
                  onClick={() => setMaximize(side)}
                />
                <p>{getTitle(side)}</p>
              </div>
              <PrimaryButton
                onClick={() => window.ToggleWoodyWallPreviewEndView(side)}
                className="minimal"
              >
                Toggle end view
              </PrimaryButton>
            </div>
            <canvas id={`preview-${side}`} width="450" height="350" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div
      className="properties-edit-popup"
      id="woody-wall-previews-maximized"
      style={{
        transform: `translate(${offset.x}px, ${offset.y}px)`,
      }}
    >
      <div className="preview-header">
        <div className="preview-header-title">
          <img
            src={minimizeIcon}
            alt="minimize-icon"
            onClick={() => setMaximize(null)}
          />
          <p>{getTitle(maximized)}</p>
        </div>
        <PrimaryButton
          onClick={() => window.ToggleWoodyWallPreviewEndView('maximized')}
          className="minimal"
        >
          Toggle end view
        </PrimaryButton>
      </div>

      <canvas id="preview-maximized" width="950" height="800" />
    </div>
  );
};

export default WoodyWallPreviewModal;
